export default __webpack_public_path__ + "static/media/pizza2.0143a95e.png";